import register from 'ShopUiBundle/modules/app/registry';
import 'ShopUiBundle/components/molecules/range-slider';
import './image-360.scss';

// tslint:disable-next-line
register('image-360', () => import(/* webpackMode: "lazy" */'./image-360'));
